import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const TokenReceiver = () => {
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {

    const query = new URLSearchParams(window.location.search);
    const token = query.get("token");
    const username = query.get("userName");
    localStorage.setItem("token", token);
    localStorage.setItem("username", username);
    setLoad(true);
  }, []);

  useEffect(() => {
    navigate("/Dashboardheader");


  }, [load]);

  return <>Will redirect in 3 seconds...</>;
};
export default TokenReceiver;
